<template>
	<div>
		<el-dialog
		    title="邀请加盟"
		    :visible.sync="InvitedVisible"
		    @closed="resetInvitedForm()"
		    :close-on-click-modal="false"
			:lock-scroll="false"
		    width="985px"
			top="30px">
		    <div v-loading="loading">
				<el-form :model="InvitedForm" ref="InvitedForm" :rules="rules">
				    <el-row>
						<el-col class="jTit">填写邀请信息</el-col>
						<div class="jBorder">
							<el-col :span="12">
							    <el-form-item
							        label="邀请单位："
							        prop="companyName"
							        label-width="120px"
							    >
							        <el-select
										style="width: 300px;"
							            v-model="InvitedForm.companyName"
							            :props="propsUser"
							            placeholder="请输入您要邀请的企业名称"
							            filterable
							            remote
							            value-key="name"
							            :remote-method="searchKey"
							            :loading="searchLoading"
							            @change="handleSelect"
							        >
							            <el-option
							                :class="{blue:item.name === InvitedForm.companyName}"
							                v-for="(item, index) in enterpriseList"
							                :key="index"
							                :label="item.name"
							                :value="item"
							            ></el-option>
							            <div
							                class="change-data"
							                @click="handleSelect('change')"
							            >
							                换一批
							            </div>
							        </el-select>
							    </el-form-item>
							</el-col>
							<el-col :span="12">
							    <el-form-item label="我的单位：" label-width="120px" prop="ownerCompanyNo">
							        <el-select placeholder="请选择我的单位" v-model="InvitedForm.ownerCompanyNo" @change="handleSelectMyCompany" style="width: 300px;">
                        <el-option :label="x.name" :value="x.no" v-for="(x,i) in myCompany" :key="i"></el-option>
                      </el-select>
							    </el-form-item>
							</el-col>
							<el-col :span="12">
							    <el-form-item
							        label="联系人："
							        prop="contacts"
							        label-width="120px"
							    >
							        <el-input
										style="width: 300px;"
							            v-model="InvitedForm.contacts"
							            placeholder="请输入联系人"
							            oninput="if(value.length>20)value=value.slice(0,20)"
							            autocomplete="off"
							        ></el-input>
							    </el-form-item>
							</el-col>
							<el-col :span="12">
							    <el-form-item
							        label="联系电话："
							        prop="phone"
							        label-width="120px"
							    >
							        <el-input
										placeholder="请输入联系电话"
										style="width: 300px;"
							            v-model="InvitedForm.phone"
							            autocomplete="off"
										maxlength="11"
							        ></el-input>
							    </el-form-item>
							</el-col>
              <el-col :span="12">
                <el-form-item label="合作类型：" label-width="120px" prop="cooperateType">
                  <el-select placeholder="请选择合作类型" v-model="InvitedForm.cooperateType" style="width: 300px;">
                    <el-option :label="x.name" :value="x.code" v-for="(x,i) in typeList" :key="i"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="供需关系：" label-width="120px" prop="relation">
                  <el-radio-group v-model="InvitedForm.relation">
                    <el-radio label="1">供方会员</el-radio>
                    <el-radio label="2">需方会员</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
							<el-col :span="24">
							    <el-form-item label="要求：" label-width="120px">
							        <el-input
										style="width: 752px;"
							            type="textarea"
							            maxlength="300"
							            placeholder="请输入要求"
							            :rows="3"
							            v-model="InvitedForm.inviteContent"
							            autocomplete="off"
							        ></el-input>
							    </el-form-item>
							</el-col>
							<el-col :offset="3" style="display: flex;align-items: center;margin-bottom: 20px;padding-left: 6px;">
								<el-button
								style="color: #B79255;border: 1px solid #B79255;"
								icon="el-icon-plus"
								:disabled="disabled"
								@click="addField()"
								>新增字段</el-button>

								<div class="jInfo">最多可新增5个字段</div>
							</el-col>
							<template v-if="InvitedForm.paramDtos.length">
								<el-col
							    v-for="(item, index) in InvitedForm.paramDtos"
							    :key="index"
							>
							    <el-row>
							        <el-col :span="3">
							            <el-form-item
							                :prop="'paramDtos.' + index + '.title'"
							                :rules="{
							                    required: true,
							                    message: '您未输入任何内容',
							                    trigger: 'blur',
							                }"
							            >
							                <el-input
							                    maxlength="10"
							                    placeholder="请输入"
							                    v-model="item.title"
							                ></el-input>
							            </el-form-item>
							        </el-col>
							        <el-col :span="18" style="margin-left: 10px">
							            <el-form-item
							                :prop="'paramDtos.' + index + '.content'"
							                :rules="{
							                    required: true,
							                    message: '您未输入任何内容',
							                    trigger: 'blur',
							                }"
							            >
							                <el-input
							                    maxlength="300"
							                    placeholder="请输入内容"
							                    v-model="item.content"
							                ></el-input>
							            </el-form-item>
							        </el-col>
							        <el-col :span="2" style="margin-left: 10px">
							            <el-button
							                @click.prevent="removeParamDtos(index)"
							                >删除</el-button
							            >
							        </el-col>
							    </el-row>
							</el-col>
							</template>
						</div>
						<div class="tc-20"></div>
						<el-col class="jTit">设置会员类型</el-col>
						<div class="jBorder">
							<el-col :span="24">
								<el-form-item label="会员等级：" label-width="120px" prop="level">
									<el-select placeholder="请选择会员等级" v-model="InvitedForm.level"  style="width:300px">
										<el-option :label="x.name" :value="x.val" v-for="(x,i) in LevelList" :key="i"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="24">
							    <el-form-item label="会员类型：" label-width="120px" prop="memberType">
							        <el-select placeholder="请选择会员类型" v-model="InvitedForm.memberType" style="width: 300px;">
									  <el-option :label="x.typeName" :value="x.no" v-for="(x,i) in memberList" :key="i"></el-option>
									</el-select>
							    </el-form-item>
							</el-col>
							<!-- <el-col :span="24">
								<el-col :offset="3">
									<div class="jInfo">说明：设置会员类型可以方便您的日常管理，之后还可以在用户中心“会员经营-企业会员”中进行修改</div>
								</el-col>
							</el-col> -->
						</div>
				    </el-row>
				</el-form>
				<div slot="footer" style="text-align: center;padding-top: 20px;">
					<el-button @click="resetInvitedForm()">取 消</el-button>
				    <el-button
					style="background: #B79255;color:#fff"
					:disabled="disabled"
					@click="submitForm('InvitedForm')"
					>提 交</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { api } from "@/api/apiJoin"
export default {
  props: {
    companyInfo: {
      required: false,
      type: Object
    }
  },
  data() {
    let validPhone = (rule, value, callback) => {
      const reg = /^1[2|3|4|5|6|7|8|9][0-9]\d{8}$/
      if (!value) {
        callback(new Error("请输入联系电话"))
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的手机号码格式"))
      } else {
        callback()
      }
    }
    let validConsigneeName = (rule, value, callback) => {
      // 验证规则
      if (this.BaseVacancy(value)) {
        callback(new Error("请输入联系人"))
      } else if (!value) {
        callback(new Error("请输入联系人"))
      } else if (value.length > 20) {
        callback(new Error("联系人不能超过20个汉字"))
      } else {
        callback()
      }
    }
    return {
      LevelList:[
        {name:'一星会员',val:'一星会员'},
        {name:'二星会员',val:'二星会员'},
        {name:'三星会员',val:'三星会员'},
        {name:'四星会员',val:'四星会员'},
        {name:'五星会员',val:'五星会员'},
        {name:'普通会员',val:'普通会员'},
      ],
      propsUser: {
        value: "no",
        label: "name"
      },
      loading: false,
      searchLoading: false,
      InvitedVisible: true,
      disabled: false,
      enterpriseList: [],
      myCompany: [],
      typeList: [],
      memberList: [],
      InvitedForm: {
        companyName: "",
        companyNo: "",
        contacts: "",
        phone: "",
        inviteContent: "",
        paramDtos: []
      },
      params: {
        page: 1,
        limit: 10,
        name: ""
      },
      rules: {
        companyName: [
          {
            required: true,
            trigger: "change",
            message: "请选择一家公司邀请其加盟"
          }
        ],
        ownerCompanyNo: [
          {
            required: true,
            trigger: "change",
            message: "请选择我的单位"
          }
        ],
        cooperateType: [
          {
            required: true,
            trigger: "change",
            message: "请选择企业合作类型"
          }
        ],
        relation: [
          {
            required: true,
            trigger: "change",
            message: "请选择供需关系"
          }
        ],
        memberType: [
          {
            required: true,
            trigger: "change",
            message: "请选择会员类型"
          }
        ],
        contacts: [
          {
            required: true,
            trigger: "blur",
            validator: validConsigneeName
          }
        ],
        phone: [
          {
            required: true,
            trigger: "blur",
            validator: validPhone
          },
          {
            min: 11,
            max: 11,
            message: "请输入正确的11位手机号码",
            trigger: "blur"
          }
        ],
        title: [
          {
            required: true,
            message: "请输入标题名称",
            trigger: "blur"
          }
        ],
        level: [
          {
            required: true,
            message: "请选择会员等级",
            trigger: "blur"
          }
        ],
      }
    }
  },
  created() {
    this.getMyCompany()
    this.getServiceTypeList()
    this.getMemberTypeList()
  },
  mounted() {
    if (this.companyInfo) {
      this.InvitedForm.companyName = this.companyInfo.name
      this.InvitedForm.companyNo = this.companyInfo.no
    }
    this.InvitedForm.ownerCompanyNo = this.$store.state.user.companyNo
  },
  methods: {
    // 获取我的单位名称
    handleSelectMyCompany(e) {
      let obj = this.myCompany.find(item => {
        return item.no === e
      })
      this.InvitedForm.applyCompanyName = e.name
      this.InvitedForm.applyCompanyNo = e.no

      this.InvitedForm.contacts = obj.concat
      this.InvitedForm.phone = obj.phone
      this.$forceUpdate()
    },
    // 获取邀请单位
    handleSelect(val) {
      if (val === "change") {
        this.InvitedForm.companyName = this.params.name
        this.params.page = ++this.params.page
        this.searchLoading = true
        this.findAllEnterprise()
      } else {
        this.InvitedForm.companyName = val.name
        this.InvitedForm.companyNo = val.no
      }
    },
    // 搜索企业
    async searchKey(queryString) {
      if (queryString) {
        this.searchLoading = true
        setTimeout(() => {
          this.params.page = 1
          this.params.name = queryString
          this.findAllEnterprise()
        }, 200)
      }
    },
    // 获取我的企业
    async getMyCompany() {
      this.loading = true
      let res = await api.getUserCompany()
      if (res.data.code === 200) {
        this.myCompany = res.data.data
        this.myCompany.forEach((e, i) => {
          if (e.no === "0") {
            this.myCompany.splice(i, 1)
          }
          if (e.no === this.$store.state.user.companyNo) {
            this.InvitedForm.applyCompanyName = e.name
            this.InvitedForm.applyCompanyNo = e.no

            this.InvitedForm.contacts = e.concat
            this.InvitedForm.phone = e.phone
          }
        })
        setTimeout(() => {
          this.loading = false
        }, 500)
      }
    },
    // 获取合作类型
    async getServiceTypeList() {
      let res = await api.getServiceTypeList()
      if (res.data.code === 200) {
        this.typeList = res.data.data
      }
    },
    // 获取会员类型
    async getMemberTypeList() {
      let res = await api.getMemberTypeList()
      if (res.data.code === 200) {
        this.memberList = res.data.data.records
      }
    },
    // 查询企业列表
    async findAllEnterprise() {
      let res = await api.searchEnterprise(this.params)
      this.searchLoading = false
      this.enterpriseList = res.data.data.records
      this.params.page = res.data.data.current
      let total = res.data.data.total
      let num = Math.ceil(total / this.params.limit)
      if (num === this.params.page) {
        this.params.page = 0
      }
    },
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.disabled = true
          let res = await api.InvitedForm(this.InvitedForm)
          if (res.data.code === 0) {
            this.$message.success(res.data.msg ? res.data.msg : '提交成功')
          } else {
            this.$message.error(res.data.msg ? res.data.msg : '提交失败')
          }
          this.$emit("closeJshow")
          this.InvitedVisible = false
          this.disabled = false
        } else {
          return false
        }
      })
    },
    // 关闭弹窗
    resetInvitedForm() {
      this.$emit("closeJshow")
      this.InvitedVisible = false
    },
    // 空白校验
    BaseVacancy(value) {
      let regu = "^[ ]+$"
      let re = new RegExp(regu)
      let bol = re.test(value)
      return bol
    },
    // 添加自定义字段
    addField() {
      if (this.InvitedForm.paramDtos.length > 4) {
        this.$message({
          message: "最多只能添加五条！",
          type: "warning"
        })
      } else {
        let obj = {
          content: "",
          title: ""
        }
        this.InvitedForm.paramDtos.push(obj)
      }
    },
    // 删除自定义字段
    removeParamDtos(i) {
      this.InvitedForm.paramDtos.splice(i, 1)
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.change-data {
  line-height: 34px;
  color: #3a8ee6;
  font-size: 14px;
  text-align: center;
  border-top: 1px solid #ebeef5;
  cursor: pointer;
}
.jTit {
  font-size: 16px;
  color: #0286df;
  padding-bottom: 20px;
}
.jBorder {
  overflow: hidden;
  padding: 20px;
  border: 1px solid #e4e7ed;
}
.jInfo {
  padding-left: 8px;
  font-size: 12px;
  color: #666666;
  line-height: 20px;
}
</style>
